import React from 'react';
import { Label } from 'components/UI/V2/Forms/Label/Label';
import { Radio } from 'components/UI/V2/Forms/Radio/Radio';
import { useRadioGroupStyles } from 'components/UI/V2/RadioGroup/RadioGroup.styles';

export interface RadioOption<T> {
    value: T;
    inlineLabel?: string;
    description?: string;
}

interface RadioGroupProps<T> {
    value: T;
    label?: string;
    error?: string;
    className?: string;
    options: RadioOption<T>[];
    onChange?: (value: T) => void;
}

export const RadioGroup = <T,>(props: RadioGroupProps<T>) => {
    const classes = useRadioGroupStyles();

    return (
        <div className={classes.root}>
            {props.label && <Label error={props.error}>{props.label}</Label>}

            <div className={`${classes.optionsContainer} ${props.className}`}>
                {props.options.map(option => (
                    <Radio
                        key={option.inlineLabel}
                        inlineLabel={option.inlineLabel}
                        description={option.description}
                        checked={props.value === option.value}
                        onChange={() => props.onChange?.(option.value)}
                    />
                ))}
            </div>
        </div>
    );
};
